import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import Slider from "components/Promotion/SliderTop"
import CampaignCountdown from "components/Promotion/CampaignCountdown"

export default function Promotion() {

    return (
        <Layout>
            <div className="styles_container__ySmzO MuiBox-root css-0">
                <div className="styles_wrapper_breadcrums__FOYxY">
                    <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
                        <ol className="MuiBreadcrumbs-ol">
                            <li className="MuiBreadcrumbs-li">
                                <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
                            </li>
                            <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                </svg>
                            </li>
                            <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Khuyến mãi</span>
                            </li>
                        </ol>
                    </nav>
                </div>
                <Slider />
                <CampaignCountdown title="Siêu Deal Cuối Năm" endTime="2025-12-31 23:59:59" />
                <CampaignCountdown title="Clearance Near Expire - Miền Nam" endTime="2026-02-28 23:59:59" />
                <CampaignCountdown title="Khuyến mãi hằng ngày" endTime="" />
            </div>
        </Layout>
    )
}
